import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeagueTeamCreateEditForm from './Components/LeagueTeamCreateEditForm';
import LeagueTeamApi from './LeagueTeamApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeagueTeamCreateEditForm,
                getCreate: LeagueTeamApi.create,
                getClone: LeagueTeamApi.getOne,
                defaults: {},
                successMessage: "Team Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}